import { render } from "./KycSuccess.vue?vue&type=template&id=e0f0e166&scoped=true"
import script from "./KycSuccess.vue?vue&type=script&lang=js"
export * from "./KycSuccess.vue?vue&type=script&lang=js"

import "./KycSuccess.vue?vue&type=style&index=0&id=e0f0e166&lang=scss&scoped=true"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0f0e166"]])

export default __exports__